import React from 'react';
import { Typography } from '@mui/material';
import People from '@mui/icons-material/People';

const LeftSideStickyCustomerList: React.FC<{
    dataLength: number;
}> = ({ dataLength }) => {
    return (
        <>
            <span>
                <People />
            </span>
            <Typography fontWeight={500}>{dataLength}</Typography>
        </>
    );
};

export default LeftSideStickyCustomerList;
